// @flow

import { beginRequest, completeRequest } from "@store/utils";
import type { AbsenceMonitoringState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);
const finishRequest = completeRequest(["requestsInProgress"]);

// Get  List

export const onUpdateAbsenceMonitoring = (state: AbsenceMonitoringState) => () =>
  startRequest(state);
export const onUpdateAbsenceMonitoringSuccess = (state: AbsenceMonitoringState) => () =>
  finishRequest(state);
export const onUpdateAbsenceMonitoringError = (state: AbsenceMonitoringState) => () =>
  finishRequest(state);

export const onResetAbsenceMonitoringState = (state: AbsenceMonitoringState) => () => ({
  ...state,
  current: null,
  draft: null,
  assignments: [],
});

export const onGetAbsenceMonitoringList = (state: AbsenceMonitoringState) => () =>
  startRequest(state);

export const onGetAbsenceMonitoringListSuccess = (state: AbsenceMonitoringState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  list: payload,
});

export const onGetAbsenceMonitoringListError = (state: AbsenceMonitoringState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get Record

export const onGet = (state: AbsenceMonitoringState) => () => startRequest(state);

export const onGetSuccess = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  current: payload,
});

export const onGetError = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get Schema

export const onGetSchema = (state: AbsenceMonitoringState) => () => startRequest(state);

export const onGetSchemaSuccess = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  schema: payload,
});

export const onGetSchemaError = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Create

export const onNew = (state: AbsenceMonitoringState) => () => ({
  ...state,
  draft: {},
});

export const onSetDraft = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  draft: payload,
});

export const onNewAssignments = (state: AbsenceMonitoringState) => () => ({
  ...state,
  assignments: [],
});

export const onSetAssignments = (state: AbsenceMonitoringState) => ({ payload }: Object) => ({
  ...state,
  assignments: payload,
});

export const onSetAbsenceMonitoringDraftAssignments = (state: AbsenceMonitoringState) => ({
  payload,
}: Object) => ({
  ...state,
  draftAssignments: payload,
});
